import React, { useEffect, useRef, useState } from "react";

const API_BASE_URL = "http://localhost:3334";

function PrintAppFind() {
  const [getPrinter, setPrinter] = useState<string[]>([]);
  const [selectedPrinters, setSelectedPrinters] = useState<string[]>([]);
  const isPrinting = useRef(false);

  useEffect(() => {
    fetchPrinterApp();
    getPrinters();
  }, []);

  const fetchPrinterApp = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/printers`);
      const data = await response.json();
      if (!response.ok) throw new Error("Failed to fetch printer app config");
      setPrinter(data.printers || []);
    } catch (error) {
      console.error("Error fetching printer app config:", error);
    }
  };

  const setDefaultPrinters = async (selectedPrinters: string[]) => {
    if (selectedPrinters.length === 0) {
      //   toast.warning("Select at least one printer");
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/set-default-printers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ printers: selectedPrinters }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      getPrinters(); // Refresh the list of default printers

      //   toast.success("Default printers saved");
    } catch (err) {
      //   toast.error(err.message);
    }
  };

  const getPrinters = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/default-printers`);
      const data = await response.json();
      setSelectedPrinters(data.printers || []);
    } catch (error) {
      console.error("Error fetching default printers:", error);
    }
  };

  const handlePrint = async (printData?: any) => {
    if (isPrinting.current) return; // 🚫 prevent duplicate calls

    isPrinting.current = true;

    try {
      const res = await fetch(`${API_BASE_URL}/print`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          printers: selectedPrinters,
          receipt: printData ?? "<!DOCTYPE html><h1>Test Print</h1><p>This is a test print from React app.</p>",
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
    } catch (err) {
      console.error("Print failed", err);
    } finally {
      isPrinting.current = false; // ✅ unlock after finished
    }
  };

  return {
    NewPrinterList: getPrinter,
    setDefaultPrinters,
    selectedPrinters,
    handlePrint,
  };
}

export default PrintAppFind;
